module.exports = __webpack_public_path__ + "static/img/product-2.288d880.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product-2.png
// module id = AfMF
// module chunks = 0